import { toLowerCase } from '@ovpn-ui/utils';

import { isEmpty, matchRegexp } from './validation-utils';

export const messages = {
    INVALID_NAME: 'Invalid name',
    INVALID_NUMBER: 'Invalid number',
    INVALID_FORMAT: 'Invalid format',
    INVALID_EMAIL: 'Invalid email',
    lessThan: (number: number) => `Cannot be less than ${number}`,
    greaterThan: (number: number) => `Cannot be greater than ${number}`,
};

const emailRegExp =
    /^(?!\.)(?=^(?:(?!\.{2}).)*$)(?=^(?:(?!\.@).)*$)([A-Z0-9.!#$%&'*+/=?^_`{|}~-])+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const match = (value: any, confirm: any, field: string) =>
    value && value !== confirm ? `${field} doesn't match` : undefined;

export const notMatch = (value: any, confirm: any, message: string) =>
    value && value === confirm ? message : undefined;

export const required = (value: any) => (isEmpty(value) ? 'Required' : undefined);

export const isTrue = (message: string) => (value: any) => (value === true ? undefined : message);

export const validLength =
    (length: number, name = 'Value') =>
    (value: string) =>
        value?.trim().length > length ? `${name} must be less than ${length} symbols` : undefined;

export const isEmail = (email: string) => matchRegexp(emailRegExp, email);

export const validEmail = (email: string) => (isEmail(email) ? undefined : messages.INVALID_EMAIL);

export const validRange =
    (min: number, max: number, name = 'Value') =>
    (value: number) =>
        value < min || value > max ? `${name} should be between ${min} and ${max}` : undefined;

export const numberInRange = (numericValue: string | number, [min, max]: [number, number]) => {
    const number = +numericValue;

    if (Number.isNaN(number)) {
        return messages.INVALID_NUMBER;
    }

    if (number < min) {
        return messages.lessThan(min);
    }

    if (number > max) {
        return messages.greaterThan(max);
    }

    return null;
};

export const nameExistsIgnoreCase = (names: string[] | null | undefined, value: string) => {
    if (Array.isArray(names)) {
        return names.some(t => toLowerCase(t) === toLowerCase(value));
    }
    return false;
};

export const hasDuplicatedNames = (names: string[] | null | undefined, value: string) => {
    if (!Array.isArray(names)) {
        return false;
    }

    const namesMap = names.reduce(
        (map, originalName = '') => {
            const name = originalName.toLowerCase();
            return {
                ...map,
                [name]: map[name] ? map[name] + 1 : 1,
            };
        },
        {} as Record<string, number>,
    );

    return namesMap[value?.toLowerCase()] > 1;
};
